import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss']

})
export class ConfirmationDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

    get yesButtonLabel(): string {
        return this.data.yesButtonLabel || 'Yes';
    }

    get noButtonLabel(): string {
        return this.data.noButtonLabel || 'No';
    }

    get hideYesButton(): boolean {
        return this.data.hideYesButton === true;
    }

    get hideNoButton(): boolean {
        return this.data.hideNoButton === true;
    }
}
